/**
 * Utilitaires centralisés pour les contraintes de sélection de dates.
 *
 * Règles globales :
 * 1. Impossible de sélectionner une date dans le passé (< aujourd'hui).
 * 2. Pour les couples chargement/déchargement : la date de déchargement
 *    doit être >= date de chargement (même jour autorisé).
 */

/** Retourne aujourd'hui à minuit (locale). */
export function startOfToday() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
}

/** Retourne `base` à minuit. */
export function startOfDay(base) {
    if (!base) return null;
    const d = new Date(base);
    d.setHours(0, 0, 0, 0);
    return d;
}

/** Calendar `disabled` prop : désactive toute date strictement passée. */
export function disablePastDates(date) {
    return startOfDay(date) < startOfToday();
}

/**
 * Calendar `disabled` prop pour la date de **déchargement** :
 *   désactive toute date avant `dateChargement` (même jour autorisé)
 *   ET toute date dans le passé.
 */
export function makeDisableBeforeDateChargement(dateChargement) {
    const chargement = dateChargement ? startOfDay(dateChargement) : null;
    return (date) => {
        const d = startOfDay(date);
        if (d < startOfToday()) return true;
        if (chargement && d < chargement) return true;
        return false;
    };
}

/**
 * Min attribute (YYYY-MM-DD) pour un input[type="date"] :
 *   - si `minDate` passé, renvoie max(today, minDate)
 *   - sinon today.
 */
export function inputDateMin(minDate) {
    const today = startOfToday();
    let min = today;
    if (minDate) {
        const m = startOfDay(minDate);
        if (m > today) min = m;
    }
    const y = min.getFullYear();
    const mo = String(min.getMonth() + 1).padStart(2, '0');
    const d = String(min.getDate()).padStart(2, '0');
    return `${y}-${mo}-${d}`;
}
